export default __webpack_public_path__ + "b5eb8dcc49b1090bf3029e1eabd370cc.png";